export default "__VITE_ASSET__D53L6r$o__"